// extracted by mini-css-extract-plugin
module.exports = {"tab":"ChipTabs_tab__BGO5N","selected":"ChipTabs_selected__CmsTv","small":"ChipTabs_small__1YIdc","withCount":"ChipTabs_withCount__2NepO","count":"ChipTabs_count__M46PQ"};